// extracted by mini-css-extract-plugin
export default {"accordionContainer":"Accordion__accordionContainer___xBzbl"};